import { Component, EventEmitter, Input, OnInit, Output, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';
import { HomecarePatient } from '../../interfaces/homecare-patient.interface';
import { BroadcastJobsUtilService } from 'src/modules/company-dashboard/services/broadcast-job-utils.service';

@Component({
  selector: 'app-shift-patient',
  templateUrl: './shift-patient.component.html',
  styleUrls: ['./shift-patient.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ShiftPatientComponent),
      multi: true
    }
  ]
})
export class ShiftPatientComponent implements OnInit,OnChanges {

  @Input() entityId: string;
  @Input() isMultiPatientAllowed: boolean = false;
  @Input() availablePatients: HomecarePatient[] = [];
  @Input() isPostalCodeRequired: boolean = false;
  @Input() formSubmitted: boolean = false;
  @Output() onPatientChange: EventEmitter<HomecarePatient> = new EventEmitter();
  @Input() patient?: HomecarePatient;
  @Input() currentView?: string;

  /**
   * Extra cssClass for the popup this select opens. The create-shift page
   * passes 'staffy-select' for the redesigned chrome; other screens pass
   * nothing and get the standard popup.
   */
  @Input() interfaceCssClass: string = '';

  /** Options handed to the ion-select popup; rebuilt only when inputs change. */
  interfaceOptions: { cssClass: string; header?: string } = { cssClass: 'references-select' };
  patientAddress: string = "";
  selectedPatient: HomecarePatient;
  displayAddress: string = '';

  get showAddressError(): boolean {
    return this.isPostalCodeRequired && this.formSubmitted && !this.displayAddress;
  }


  constructor(
    private utilService: BroadcastJobsUtilService
  ) { }

  private buildInterfaceOptions() {
    this.interfaceOptions = {
      cssClass: ('references-select ' + this.interfaceCssClass).trim(),
      header: 'Patient ID',
    };
  }

  ngOnInit() {
    this.buildInterfaceOptions();
    if(this.patient){
      this.selectedPatient = this.patient;
      this.displayAddress = this.patient?.address?.street || '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildInterfaceOptions();
    if(this.patient){
      this.selectedPatient = this.patient;
      this.displayAddress = this.patient?.address?.street || '';
    }
  }

  handlePatientIdChange(){
    // Auto-populate the address field from the selected patient,
    // but keep displayAddress as independent state going forward
    this.displayAddress = this.selectedPatient?.address?.street || '';
    this.onPatientChange.emit(this.selectedPatient);
  }

  handleAddressChange(address){
    const formattedAddress = this.utilService.getFormatedAddress(address);
    // Update displayAddress independently so Angular binding does not reset it
    this.displayAddress = address?.formatted_address || '';
    // Always emit the address so the parent can update companyAddress,
    // even if no patient has been selected yet (id will be empty string).
    this.onPatientChange.emit({ id: this.selectedPatient?.id || '', address: formattedAddress });
  }

  trackByPatient(i: number, patient: HomecarePatient): string {
    return patient.id;
  }
 
  comparePatients(p1: HomecarePatient, p2: HomecarePatient): boolean {
  return p1 && p2 ? p1.id === p2.id : p1 === p2;
}

  reset() {
    this.selectedPatient = undefined;
    this.patientAddress = '';
    this.displayAddress = '';
  }
}